// import tns from "tiny-slider";
import { tns } from 'tiny-slider/src/tiny-slider.module.js';
import 'tiny-slider/dist/tiny-slider.css';
import 'tiny-slider/dist/tiny-slider.helper.ie8.js';

import '../../../src/docReady.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import Match from '../../../src/Match.js'; // easing
import './style.scss';

const moduleSelector = '.eiovisual-magazine1';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo magazine1');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {
    
    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        // Tasks on images
        setTimeout(() => { this.task1() },0); // Stessa altezza per i titoli
        setTimeout(() => { this.task2() },0); // Stessa altezza per i text
        setTimeout(() => { this.task3() },0); // Stessa altezza per le tags
        setTimeout(() => { this.task4() },100);
    }

    /**
     * @returns {undefined}
     */
    task1() {
        // uniforma l'altezza degli elementi
        Match.height(this.$module.querySelectorAll('.item .title'));
    }
    
    /**
     * @returns {undefined}
     */
    task2() {
        // uniforma l'altezza degli elementi
        Match.height(this.$module.querySelectorAll('.item .text'));
    }

    /**
     * @returns {undefined}
     */
    task3() {
        // uniforma l'altezza degli elementi
        Match.height(this.$module.querySelectorAll('.item .tags'));
    }


    /**
     * tiny slider
     * @returns {undefined}
     */
    task4() {

        var that = this;
        var id = this.$module.getAttribute('id');

        /* EC modfica control slider per frecce - 21/04/20 */

        // DOCUMENTATION
        // https://github.com/ganlanyuan/tiny-slider
        var slider = tns({
            container: '#magazine-' + id,
            items: 1,
            mode:'gallery',
            items:1,
            slideBy: 'page',
            autoplay: false,
            autoWidth:false,
            mouseDrag:true,
            touch:true,
            nav: true,
            controls: true,
            swipeAngle: 25
            // preventScrollOnTouch:true
          });

    }

}

// export
export default new Module();